module.exports = __webpack_public_path__ + "static/media/strong_oppose_selected.e37ac78f.png";